import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNumber4Square: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="number-4-square, key"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M12.4336 16.2275V14.6045H8.29688V13.3682C9.39258 11.4639 10.5938 9.51855 11.7422 7.77246H13.8809V13.3564H15.0176V14.6045H13.8809V16.2275H12.4336ZM9.70312 13.3916H12.457V8.97949H12.3691C11.502 10.3037 10.5234 11.8682 9.70312 13.3037V13.3916Z" fill="currentColor"/></CentralIconBase>;
};

export default IconNumber4Square;
